var map = {
	"./Hyphen.png": 92536,
	"./Hyu.png": 97138,
	"./Lifespan.png": 48312,
	"./Renee.png": 90923,
	"./Snitch.png": 13821,
	"./Swiss Beauty.png": 81172,
	"./WeRize.png": 42104,
	"./adidas.png": 26586,
	"./amazon.png": 13486,
	"./beato.png": 72518,
	"./bella-vita.png": 85688,
	"./boat.png": 89879,
	"./boldcare.png": 65126,
	"./bombay-shaving-company.png": 36451,
	"./booking-com.png": 91893,
	"./cadbury.png": 39024,
	"./clove-oral-care.png": 32606,
	"./croma.png": 13425,
	"./dot-and-key.png": 83349,
	"./fab-india.png": 24348,
	"./firstcry.png": 92684,
	"./fitspire.png": 75611,
	"./flipkart.png": 20920,
	"./forest-essentials-india.png": 50325,
	"./foxtale.png": 87601,
	"./giva.png": 3767,
	"./go-noise.png": 65550,
	"./kama.png": 40404,
	"./koparo-clean.png": 69042,
	"./libas.png": 51075,
	"./mamaearth.png": 58683,
	"./mcaffeine.png": 9411,
	"./medibuddy.png": 99345,
	"./minimalist.png": 64841,
	"./muscleblaze.png": 72809,
	"./neeman.png": 79026,
	"./nykaa.png": 51318,
	"./plum-goodness.png": 50293,
	"./puer.png": 23739,
	"./puma.png": 84414,
	"./shopsy.png": 12401,
	"./shyaway.png": 27237,
	"./smytten.png": 81725,
	"./sova-health.png": 62821,
	"./ssbeauty.png": 82091,
	"./the-derma-co.png": 10575,
	"./the-man-company.png": 30038,
	"./times-prime.png": 40257,
	"./truemeds.png": 60077,
	"./weryze.png": 44974,
	"./world-of-asaya.png": 39954,
	"./wow.png": 56964,
	"./xyxx-crew.png": 98076,
	"./zandu-care.png": 24043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57916;